import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'

// Import single card component
import BkFlowRoomCard from './BkFlowRoomCard'
import hasValidRoomTypeCodes from '../../utilities/content/hasValidRoomTypeCodes'

import '../../styles/css/components/room/bk-flow-room-cards.css'

import _  from 'lodash'
import yn from 'yn'
import moment from "moment";

class BkFlowRoomCards extends Component {

	constructor(props) {
		super(props)
		this.state = {
		}
	}

	toggleEditStay = () => {
		const targetEditStay = 'bk-toggle-edit-stay'
		document.getElementById(targetEditStay).click()
	}

	renderCards() {
		const {
			configData,
			urlData,
			availabilityData
		} = this.props

		const roomGroup = this.props.roomGroup
		const hotelLabels = configData.hotel.labels[0]
		const rooms = _.get(availabilityData, `${[roomGroup]}[0].roomTypes`, [])

		let activeHotelCode = null
		let activeHotelPhoneNumber = null

		if (
			!_.isEmpty(urlData) &&
			urlData.hotelCode
		) {
			activeHotelCode = urlData.hotelCode
		}

		if (!_.isEmpty(configData)) {
			const configProperties = configData.hotel.options.properties

			// Match activeHotelCode to config properties array
			const matchedProperty = configProperties.find(function(property) {
				return property.hotelCode === String(activeHotelCode)
			})

			// Set phone # by config or synxis fallback
			if (
				!_.isEmpty(matchedProperty) &&
				matchedProperty.contactNumbers &&
				matchedProperty.contactNumbers.reservations
			) {
				activeHotelPhoneNumber = matchedProperty.contactNumbers.reservations
			} else if (
				!_.isEmpty(availabilityData.hotelReservations) &&
				_.get(availabilityData.hotelReservations, '[0].roomStays[0].basicPropertyInfo.contactNumbers[0].phoneNumber')
			) {
				activeHotelPhoneNumber = availabilityData.hotelReservations[0].roomStays[0].basicPropertyInfo.contactNumbers[0].phoneNumber
			} else if (
				!_.isEmpty(availabilityData.hotelResModifies) &&
				_.get(availabilityData.hotelResModifies, '[0].roomStays[0].basicPropertyInfo.contactNumbers[0].phoneNumber')
			) {
				activeHotelPhoneNumber = availabilityData.hotelResModifies[0].roomStays[0].basicPropertyInfo.contactNumbers[0].phoneNumber
			}
		}

		const urlRoomTypes = _.get(urlData, 'roomTypeCode', [])
		// Begin Render Card Layouts
		if (
			rooms.length > 0 &&
			hasValidRoomTypeCodes(rooms)
		) {

			if (urlData.accessible === 'true') {
				const accessibleRooms = rooms.filter(room => room.viewExtensions.isAccessible)
				if (
					accessibleRooms &&
					!_.isEmpty(accessibleRooms)
				) {
					return accessibleRooms.map((cards, index) => {
						return (
							<BkFlowRoomCard
								key={cards.roomTypeCode}
								cards={cards}
								roomGroup={roomGroup}
								roomKey={index}
							/>
						)
					})
				} else {
					return (
						<div className="bk-flow-room__no-results">
							<h4>{hotelLabels.noAvailAccessibleTitle ? hotelLabels.noAvailAccessibleTitle : 'No Results'}</h4>
							<p className="u-remove-margin">
								{hotelLabels.noAvailAccessibleMessage ?
									hotelLabels.noAvailAccessibleMessage
									:
									'It appears there is no accessible rooms available based on your current booking request.'
								}
							</p>

							{activeHotelPhoneNumber &&
							<p>
								{hotelLabels.noAvailContact ?
									hotelLabels.noAvailContact
									:
									'For immediate bookings or reservation questions please contact us at'
								}<a className="bk-flow-room__no-results-phone"
								    href={'tel:' + activeHotelPhoneNumber}>{': ' + activeHotelPhoneNumber}</a>
							</p>
							}

							<button
								className="btn btn-text-only"
								onClick={() => this.toggleEditStay()}
							>
								{hotelLabels.editStay ? hotelLabels.editStay : 'Edit Stay'}
							</button>
						</div>
					)
				}
			} if (
				yn(process.env.REACT_APP_COMPONENT_ENABLE_QUERIED_ROOM_RATE_SORTING) &&
				!_.isEmpty(urlRoomTypes)
			) {
				const urlRoomsArray = urlRoomTypes.split(',')

				const queriedRooms = []
				const remainingRooms = []

				for (let i = 0; i < rooms.length; i ++) {
					const currentRoom = rooms[i]

					if (_.includes(urlRoomsArray, currentRoom.roomTypeCode)) {
						queriedRooms.push(currentRoom)
					} else {
						remainingRooms.push(currentRoom)
					}
				}

				return (
					<Fragment>
						{!_.isEmpty(queriedRooms) ? (
							<div className="bk-flow-room__defined-results">
								{ queriedRooms.map((cards, index) => {
									return (
										<BkFlowRoomCard
											key={ cards.roomTypeCode }
											cards={ cards }
											roomGroup={ roomGroup }
											roomKey={ index }
										/>
									)
							})}
							</div>
						) : (
							<div className="bk-flow-room__queried-results-error">
								<p>
									{hotelLabels.queriedRoomsUnavailableMessage ? (
										hotelLabels.queriedRoomsUnavailableMessage
									) : (
										'The selected rooms are unavailable for your current booking request.'
									)}
								</p>
							</div>
						)}

						<div className="bk-flow-room__queried-results-divider">
							<h5>
								{hotelLabels.queriedRoomsDividerMessage ?
									hotelLabels.queriedRoomsDividerMessage
								:
									'Other rooms available for your selected dates'
								}
							</h5>
						</div>

						{!_.isEmpty(remainingRooms) && (
							<div className="bk-flow-room__general-results">
								{ remainingRooms.map((cards, index) => {
									return (
										<BkFlowRoomCard
											key={ cards.roomTypeCode }
											cards={ cards }
											roomGroup={ roomGroup }
											roomKey={ index }
										/>
									)
								})}
							</div>
						)}
					</Fragment>
				)
			}  else if (yn(process.env.REACT_APP_COMPONENT_ROOM_FILTERS_SORT_ACCESSIBLE_DOWN)) {
					// sort by defaults to ascending sort order
					const sortedRooms =  _.sortBy(rooms, item => _.get(item, 'viewExtensions.isAccessible'))
					return _.map(sortedRooms, (cards, index) => (
						<BkFlowRoomCard
							key={ _.get(cards, 'roomTypeCode') }
							cards={ cards }
							roomGroup={ roomGroup }
							roomKey={ index }
						/>
					))
			} else {
				return rooms.map((cards, index) => {
					return (
						<BkFlowRoomCard
							key={ cards.roomTypeCode }
							cards={ cards }
							roomGroup={ roomGroup }
							roomKey={ index }
						/>
					)
				})
			}
		} else {
			// Adding check for SLS South Beach to see if it's during their construction TODO... (SBE100-2681) remove once construction is done
			let underConstruction = moment(urlData.startDate).isSameOrAfter(moment('2025-05-28')) || moment(urlData.endDate).isSameOrAfter(moment('2025-05-28'))
			return (
				<div className="bk-flow-room__no-results">
					<h4>{ hotelLabels.noAvailTitle ? hotelLabels.noAvailTitle : 'No Results' }</h4>
					{ activeHotelCode === 'B5C4' && underConstruction ?
						<p>
							From May 28, 2025, SLS South Beach will close the entire property to undergo an exciting and extensive renovation. If you have an upcoming reservation, please contact <a href="mailto:reservations.southbeach@slshotels.com">reservations.southbeach@slshotels.com</a>.
						</p>
						:
						<p className="u-remove-margin">
							{ hotelLabels.noAvailMessage ?
								hotelLabels.noAvailMessage
							:
								'It appears there is no room availability based on your current booking request.'
							}
						</p>
					}

					{ activeHotelPhoneNumber &&
						<p>
							{ hotelLabels.noAvailContact ?
								hotelLabels.noAvailContact
							:
								'For immediate bookings or reservation questions please contact us at'
							}<a className="bk-flow-room__no-results-phone" href={ 'tel:' + activeHotelPhoneNumber }>{ ': ' + activeHotelPhoneNumber }</a>
						</p>
					}

					<button
						className="btn btn-text-only"
						onClick={ () => this.toggleEditStay() }
					>
						{ hotelLabels.editStay ? hotelLabels.editStay : 'Edit Stay' }
					</button>
				</div>
			)
		}
	}

	render() {
		return (
			<div className={ yn(process.env.REACT_APP_COMPONENT_ROOM_HEADING) ?
				'bk-flow-room__cards include-heading'
			:
				'bk-flow-room__cards'
			}>
				{ this.renderCards() }
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
		configData: state.configData.configuration,
		currentQuery: state.availabilityData.currentQuery,
		availabilityData: state.availabilityData.availability,
		urlData: state.availabilityData.urlData
	}
}



export default connect(mapStateToProps, null)(BkFlowRoomCards)


// WEBPACK FOOTER //
// ./src/components/room/BkFlowRoomCards.js